// extracted by mini-css-extract-plugin
module.exports = {"loading-spinner":"_141hZYiwThdhA57ssxGhI4"};